import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';

export interface MarkInvestigationMessagesAsReadQuery { investigationId: string; }

@Injectable({ providedIn: 'root' })
export class MarkInvestigationMessagesAsReadUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: MarkInvestigationMessagesAsReadQuery): Observable<void> {
    this._state.setErrorMessages(null);
    return this._repository.markMessagesAsRead(query.investigationId).pipe(
      catchError((error) => {
        this._state.setErrorMessages(error.message || 'Failed to mark messages as read');
        return throwError(() => error);
      }),
    );
  }
}
